import React from "react";
import { Box, TextField, MenuItem, Grid } from "@mui/material";
import countries from "world-countries";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css"; // Material UI style

const CustomAddressForm = ({
  isCheckout,
  shippingDetails = { country: "in" }, // lowercase ISO code for default country
  shippingErrors,
  handleShippingChange,
}) => {
  // Prepare country list (A–Z sort)
  const countryList = countries
    .map((c) => ({ name: c.name.common }))
    .sort((a, b) => a.name.localeCompare(b.name));
  return (
    <Box
      sx={{
        p: isCheckout ? 0 : 2,
        pt: isCheckout ? 0 : 2,
        display: "flex",
        flexDirection: "column",
        backgroundColor: isCheckout ? "" : "#f6f6f6",
      }}
    >
      <TextField
        fullWidth
        select
        label="Country/Region"
        name="country"
        sx={textFieldStyles}
        value={shippingDetails.country}
        onChange={handleShippingChange}
        margin="normal"
        error={Boolean(shippingErrors?.country)}
        helperText={shippingErrors?.country}
      >
        {countryList.map((country) => (
          <MenuItem key={country.name} value={country.name}>
            {country.name}
          </MenuItem>
        ))}
      </TextField>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="firstName"
            label="First name"
            value={shippingDetails.firstName || ""}
            onChange={handleShippingChange}
            required
            margin="normal"
            error={Boolean(shippingErrors?.firstName)}
            helperText={shippingErrors?.firstName}
            sx={textFieldStyles}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="lastName"
            label="Last name"
            value={shippingDetails.lastName || ""}
            onChange={handleShippingChange}
            required
            margin="normal"
            error={Boolean(shippingErrors?.lastName)}
            helperText={shippingErrors?.lastName}
            sx={textFieldStyles}
          />
        </Grid>
      </Grid>

      <TextField
        fullWidth
        name="company"
        label="Company (optional)"
        value={shippingDetails.company || ""}
        onChange={handleShippingChange}
        margin="normal"
        sx={textFieldStyles}
      />

      <TextField
        fullWidth
        name="address1"
        label="Address"
        value={shippingDetails.address1 || ""}
        onChange={handleShippingChange}
        required
        margin="normal"
        error={Boolean(shippingErrors?.address1)}
        helperText={shippingErrors?.address1}
        sx={textFieldStyles}
      />

      <TextField
        fullWidth
        name="address2"
        label="Apartment, suite, etc. (optional)"
        value={shippingDetails.address2 || ""}
        onChange={handleShippingChange}
        margin="normal"
        error={Boolean(shippingErrors?.address2)}
        helperText={shippingErrors?.address2}
        sx={textFieldStyles}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="city"
            label="City"
            value={shippingDetails.city || ""}
            onChange={handleShippingChange}
            required
            margin="normal"
            error={Boolean(shippingErrors?.city)}
            helperText={shippingErrors?.city}
            sx={textFieldStyles}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            name="zipCode"
            label="Postcode"
            value={shippingDetails.zipCode || ""}
            onChange={handleShippingChange}
            required
            margin="normal"
            error={Boolean(shippingErrors?.zipCode)}
            helperText={shippingErrors?.zipCode}
            sx={textFieldStyles}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 0.4 }}>
        <Grid item xs={12}>
          <PhoneInput
            country={"in"}
            value={shippingDetails.phone || ""}
            onChange={(phone, country) =>
              handleShippingChange({
                target: {
                  name: "phone",
                  value: phone,
                  countryCode: country.dialCode,
                  country: country.countryCode.toUpperCase(),
                },
              })
            }
            inputStyle={{
              width: "100%",
              borderRadius: "10px",
              height: "56px",
              borderColor: shippingErrors?.phone ? "red" : "#ccc",
              outline: "none",
              boxShadow: "none", // remove default blue
            }}
            containerStyle={{ width: "100%" }}
            dropdownStyle={{ maxHeight: "200px" }}
            specialLabel="Phone *"
            inputProps={{
              name: "phone",
              required: true,
              autoFocus: false,
              onFocus: (e) => {
                e.target.style.borderColor = "black";
                e.target.style.boxShadow = "0 0 0 1px #000000";
              },
              onBlur: (e) => {
                e.target.style.borderColor = shippingErrors?.phone
                  ? "red"
                  : "#ccc";
                e.target.style.boxShadow = "none";
              },
            }}
          />

          {shippingErrors?.phone && (
            <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              {shippingErrors.phone}
            </p>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

// Shared text field styles
const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "white",
    "& fieldset": {
      borderColor: "#ccc",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
  "& .MuiInputLabel-root": {
    color: "black",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "black",
  },
};

export default CustomAddressForm;
